<template>
  <!-- Add Attendance Modal -->
  <div id="add_attendance" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Attendance</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="addattendanceclose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onSubmit">
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Employee <span class="text-danger">*</span></label
              >
              <Field
                name="employee_id"
                as="select"
                class="form-control"
                v-model="form.employee_id"
                :class="{
                  'is-invalid': backendErrors && backendErrors.employee_id,
                }"
              >
                <option value="">Select Employee</option>
                <option
                  v-for="employee in employeelist"
                  :key="employee.id"
                  :value="employee.id"
                >
                  {{ employee.text }}
                </option>
              </Field>
              <div class="invalid-feedback">
                <span
                  v-if="
                    backendErrors &&
                    backendErrors.employee_id &&
                    backendErrors.employee_id != null
                  "
                >
                  {{ backendErrors?.employee_id[0] }}
                </span>
              </div>
            </div>

            <!-- <div class="input-block mb-3">
              <label class="col-form-label"
                >Date <span class="text-danger">*</span></label
              >
              <div
                class="cal-icon"
                :class="{ 'date-error': backendErrors && backendErrors?.date }"
              >
                <vue-datepicker
                  v-model="form.date"
                  placeholder="Choose Date"
                  :max-date="maxDate"
                  :enable-time-picker="false"
                  :auto-apply="true"
                  :clearable="false"
                  :format="dateFormat"
                />
              </div>
              <span
                class="error-msg"
                v-if="
                  backendErrors &&
                  backendErrors.date &&
                  backendErrors.date != null
                "
              >
                {{ backendErrors?.date[0] }}
              </span>
            </div> -->

            <div class="input-block mb-3">
              <label class="col-form-label"
                >Punch From <span class="text-danger">*</span></label
              >
              <Field
                name="punch_from"
                as="select"
                class="form-control"
                v-model="form.punch_from"
                :class="{
                  'is-invalid': backendErrors && backendErrors.punch_from,
                }"
              >
                <option value="">Select Punch From</option>
                <option value="1">Office</option>
                <option value="2">Home</option>
              </Field>
              <div class="invalid-feedback">
                <span
                  v-if="
                    backendErrors &&
                    backendErrors.punch_from &&
                    backendErrors.punch_from != null
                  "
                >
                  {{ backendErrors?.punch_from[0] }}
                </span>
              </div>
            </div>

            <!-- <div class="row">
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Punch In Time <span class="text-danger">*</span></label
                  >
                  <div class="input-group time">
                    <a-time-picker
                      v-model:value="form.punch_in_time"
                      class="form-control timepicker"
                      placeholder="HH:mm"
                      :format="'HH:mm'"
                      :disabled="!form.date"
                      :class="{
                        'is-invalid':
                          backendErrors && backendErrors.punch_in_time,
                      }"
                    />
                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                  <span
                    class="error-msg"
                    v-if="
                      backendErrors &&
                      backendErrors.punch_in_time &&
                      backendErrors.punch_in_time != null
                    "
                  >
                    {{ backendErrors?.punch_in_time[0] }}
                  </span>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Punch Out Time <span class="text-danger">*</span></label
                  >
                  <div class="input-group time">
                    <a-time-picker
                      v-model:value="form.punch_out_time"
                      class="form-control timepicker"
                      placeholder="HH:mm"
                      :format="'HH:mm'"
                      :class="{
                        'is-invalid':
                          backendErrors && backendErrors.punch_out_time,
                      }"
                      :disabled="!form.punch_in_time"
                    />
                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                  <span
                    class="error-msg"
                    v-if="
                      backendErrors &&
                      backendErrors.punch_out_time &&
                      backendErrors.punch_out_time != null
                    "
                  >
                    {{ backendErrors?.punch_out_time[0] }}
                  </span>
                </div>
              </div>
            </div> -->

            <div class="row">
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Punch In Date <span class="text-danger">*</span></label
                  >
                  <div
                    class="cal-icon"
                    :class="{
                      'date-error':
                        backendErrors && backendErrors?.punch_in_date,
                    }"
                  >
                    <vue-datepicker
                      v-model="form.punch_in_date"
                      placeholder="Choose Date"
                      :max-date="maxDate"
                      :enable-time-picker="false"
                      :auto-apply="true"
                      :clearable="false"
                      :format="dateFormat"
                    />
                  </div>
                  <span
                    class="error-msg"
                    v-if="
                      backendErrors &&
                      backendErrors.punch_in_date &&
                      backendErrors.punch_in_date != null
                    "
                  >
                    {{ backendErrors?.punch_in_date[0] }}
                  </span>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Punch In Time <span class="text-danger">*</span></label
                  >
                  <div class="input-group time">
                    <a-time-picker
                      v-model:value="form.punch_in_time"
                      class="form-control timepicker"
                      placeholder="HH:mm"
                      :format="'HH:mm'"
                      :disabled="!form.punch_in_date"
                      :class="{
                        'is-invalid':
                          backendErrors && backendErrors.punch_in_time,
                      }"
                    />
                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                  <span
                    class="error-msg"
                    v-if="
                      backendErrors &&
                      backendErrors.punch_in_time &&
                      backendErrors.punch_in_time != null
                    "
                  >
                    {{ backendErrors?.punch_in_time[0] }}
                  </span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Punch Out Date <span class="text-danger">*</span></label
                  >
                  <div
                    class="cal-icon"
                    :class="{
                      'date-error':
                        backendErrors && backendErrors?.punch_out_date,
                    }"
                  >
                    <vue-datepicker
                      v-model="form.punch_out_date"
                      placeholder="Choose Date"
                      :min-date="form.punch_in_date"
                      :max-date="maxPunchOutDate"
                      :enable-time-picker="false"
                      :auto-apply="true"
                      :clearable="false"
                      :format="dateFormat"
                    />
                  </div>
                  <span
                    class="error-msg"
                    v-if="
                      backendErrors &&
                      backendErrors.punch_out_date &&
                      backendErrors.punch_out_date != null
                    "
                  >
                    {{ backendErrors?.punch_out_date[0] }}
                  </span>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Punch Out Time <span class="text-danger">*</span></label
                  >
                  <div class="input-group time">
                    <a-time-picker
                      v-model:value="form.punch_out_time"
                      class="form-control timepicker"
                      placeholder="HH:mm"
                      :format="'HH:mm'"
                      :class="{
                        'is-invalid':
                          backendErrors && backendErrors.punch_out_time,
                      }"
                      :disabled="!form.punch_in_time"
                    />
                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                  <span
                    class="error-msg"
                    v-if="
                      backendErrors &&
                      backendErrors.punch_out_time &&
                      backendErrors.punch_out_time != null
                    "
                  >
                    {{ backendErrors?.punch_out_time[0] }}
                  </span>
                </div>
              </div>
            </div>

            <div class="d-flex mb-3">
              <label class="col-form-label">Break Taken: </label>
              <div class="form-check form-switch">
                <input
                  v-model="form.is_break"
                  type="checkbox"
                  class="form-check-input"
                  id="breakToggle"
                />
              </div>
            </div>

            <!-- <div v-if="form.is_break">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Break Reason <span class="text-danger">*</span></label
                >
                <Field
                  name="break_reason"
                  as="select"
                  class="form-control"
                  v-model="form.break_reason"
                  :class="{
                    'is-invalid': backendErrors && backendErrors.break_reason,
                  }"
                >
                  <option value="">Select Break Reason</option>
                  <option
                    v-for="reason in punchOutOptions"
                    :key="reason"
                    :value="reason"
                  >
                    {{ reason }}
                  </option>
                </Field>
                <div class="invalid-feedback">
                  <span
                    v-if="
                      backendErrors &&
                      backendErrors.break_reason &&
                      backendErrors.break_reason != null
                    "
                  >
                    {{ backendErrors?.break_reason[0] }}
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label"
                      >Break Start Time
                      <span class="text-danger">*</span></label
                    >
                    <div class="input-group time">
                      <a-time-picker
                        v-model:value="form.break_start_time"
                        class="form-control timepicker"
                        placeholder="HH:mm"
                        :format="'HH:mm'"
                        :disabled="!form.punch_in_time"
                        :class="{
                          'is-invalid':
                            backendErrors && backendErrors.break_start_time,
                        }"
                      />
                      <span class="input-group-text"
                        ><i class="fa-regular fa-clock"></i
                      ></span>
                    </div>
                    <span
                      class="error-msg"
                      v-if="
                        backendErrors &&
                        backendErrors.break_start_time &&
                        backendErrors.break_start_time != null
                      "
                    >
                      {{ backendErrors?.break_start_time[0] }}
                    </span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label"
                      >Break End Time <span class="text-danger">*</span></label
                    >
                    <div class="input-group time">
                      <a-time-picker
                        v-model:value="form.break_end_time"
                        class="form-control timepicker"
                        :class="{
                          'is-invalid':
                            backendErrors && backendErrors.break_end_time,
                        }"
                        placeholder="HH:mm"
                        :format="'HH:mm'"
                        :disabled="!form.break_start_time"
                      />
                      <span class="input-group-text"
                        ><i class="fa-regular fa-clock"></i
                      ></span>
                    </div>
                    <span
                      class="error-msg"
                      v-if="
                        backendErrors &&
                        backendErrors.break_end_time &&
                        backendErrors.break_end_time != null
                      "
                    >
                      {{ backendErrors?.break_end_time[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div> -->

            <div v-if="form.is_break">
              <div class="input-block mb-3">
                <label class="col-form-label"
                  >Break Reason <span class="text-danger">*</span></label
                >
                <Field
                  name="break_reason"
                  as="select"
                  class="form-control"
                  v-model="form.break_reason"
                  :class="{
                    'is-invalid': backendErrors && backendErrors.break_reason,
                  }"
                >
                  <option value="">Select Break Reason</option>
                  <option
                    v-for="reason in punchOutOptions"
                    :key="reason"
                    :value="reason"
                  >
                    {{ reason }}
                  </option>
                </Field>
                <div class="invalid-feedback">
                  <span
                    v-if="
                      backendErrors &&
                      backendErrors.break_reason &&
                      backendErrors.break_reason != null
                    "
                  >
                    {{ backendErrors?.break_reason[0] }}
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label"
                      >Break Start Date
                      <span class="text-danger">*</span></label
                    >
                    <div
                      class="cal-icon"
                      :class="{
                        'date-error':
                          backendErrors && backendErrors?.break_start_date,
                      }"
                    >
                      <vue-datepicker
                        v-model="form.break_start_date"
                        placeholder="Choose Date"
                        :min-date="form.punch_in_date"
                        :max-date="form.punch_out_date"
                        :enable-time-picker="false"
                        :auto-apply="true"
                        :clearable="false"
                        :format="dateFormat"
                      />
                    </div>
                    <span
                      class="error-msg"
                      v-if="
                        backendErrors &&
                        backendErrors.break_start_date &&
                        backendErrors.break_start_date != null
                      "
                    >
                      {{ backendErrors?.break_start_date[0] }}
                    </span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label"
                      >Break Start Time
                      <span class="text-danger">*</span></label
                    >
                    <div class="input-group time">
                      <a-time-picker
                        v-model:value="form.break_start_time"
                        class="form-control timepicker"
                        placeholder="HH:mm"
                        :format="'HH:mm'"
                        :disabled="!form.punch_in_time"
                        :class="{
                          'is-invalid':
                            backendErrors && backendErrors.break_start_time,
                        }"
                      />
                      <span class="input-group-text"
                        ><i class="fa-regular fa-clock"></i
                      ></span>
                    </div>
                    <span
                      class="error-msg"
                      v-if="
                        backendErrors &&
                        backendErrors.break_start_time &&
                        backendErrors.break_start_time != null
                      "
                    >
                      {{ backendErrors?.break_start_time[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label"
                      >Break End Date <span class="text-danger">*</span></label
                    >
                    <div
                      class="cal-icon"
                      :class="{
                        'date-error':
                          backendErrors && backendErrors?.break_end_date,
                      }"
                    >
                      <vue-datepicker
                        v-model="form.break_end_date"
                        placeholder="Choose Date"
                        :min-date="form.break_start_date || form.punch_in_date"
                        :max-date="form.punch_out_date"
                        :enable-time-picker="false"
                        :auto-apply="true"
                        :clearable="false"
                        :format="dateFormat"
                      />
                    </div>
                    <span
                      class="error-msg"
                      v-if="
                        backendErrors &&
                        backendErrors.break_end_date &&
                        backendErrors.break_end_date != null
                      "
                    >
                      {{ backendErrors?.break_end_date[0] }}
                    </span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label"
                      >Break End Time <span class="text-danger">*</span></label
                    >
                    <div class="input-group time">
                      <a-time-picker
                        v-model:value="form.break_end_time"
                        class="form-control timepicker"
                        :class="{
                          'is-invalid':
                            backendErrors && backendErrors.break_end_time,
                        }"
                        placeholder="HH:mm"
                        :format="'HH:mm'"
                        :disabled="!form.break_start_time"
                      />
                      <span class="input-group-text"
                        ><i class="fa-regular fa-clock"></i
                      ></span>
                    </div>
                    <span
                      class="error-msg"
                      v-if="
                        backendErrors &&
                        backendErrors.break_end_time &&
                        backendErrors.break_end_time != null
                      "
                    >
                      {{ backendErrors?.break_end_time[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- Add Attendance Modal -->

  <!-- Edit Attendance Modal -->
  <div id="edit_attendance" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Attendance</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="editattendanceclose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onUpdate">
            <div class="input-block mb-3">
              <label class="col-form-label">Employee</label>
              <input
                type="text"
                class="form-control"
                :value="getEmployeeName(editForm.employee_id)"
                disabled
              />
            </div>

            <!-- <div class="input-block mb-3">
              <label class="col-form-label">Date</label>
              <div class="cal-icon">
                <input
                  type="text"
                  class="form-control"
                  :value="formatDisplayDate(editForm.date)"
                  disabled
                />
              </div>
            </div> -->

            <div class="row">
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Punch In Date </label>
                  <div class="cal-icon">
                    <vue-datepicker
                      v-model="editForm.punch_in_date"
                      placeholder="Choose Date"
                      :max-date="maxDate"
                      :enable-time-picker="false"
                      :auto-apply="true"
                      :clearable="false"
                      :format="dateFormat"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Punch In Time </label>
                  <div class="input-group time">
                    <a-time-picker
                      v-model:value="editForm.punch_in_time"
                      class="form-control timepicker"
                      placeholder="HH:mm"
                      :format="'HH:mm'"
                    />
                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label"
                    >Punch Out Date <span class="text-danger">*</span></label
                  >
                  <div class="cal-icon">
                    <vue-datepicker
                      v-model="editForm.punch_out_date"
                      placeholder="Choose Date"
                      :min-date="editForm.punch_in_date"
                      :max-date="maxPunchOutDate"
                      :enable-time-picker="false"
                      :auto-apply="true"
                      :clearable="false"
                      :format="dateFormat"
                    />
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Punch Out Time </label>
                  <div class="input-group time">
                    <a-time-picker
                      v-model:value="editForm.punch_out_time"
                      class="form-control timepicker"
                      placeholder="HH:mm"
                      :format="'HH:mm'"
                    />
                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex mb-3">
              <label class="col-form-label">Break Taken: </label>
              <div class="form-check form-switch">
                <input
                  v-model="editForm.is_break"
                  type="checkbox"
                  class="form-check-input"
                  id="breakToggle"
                  @change="handleBreakToggle"
                />
              </div>
            </div>

            <div v-if="editForm.is_break">
              <div
                v-for="(breakItem, index) in editForm.break_details"
                :key="index"
                class="break-section"
              >
                <div
                  class="d-flex justify-content-between align-items-center mb-3"
                >
                  <h5 class="mb-0">Break {{ index + 1 }}</h5>
                  <button
                    v-if="editForm.break_details.length > 1"
                    type="button"
                    class="btn btn-sm btn-danger"
                    @click="removeBreak(index)"
                  >
                    Remove
                  </button>
                </div>

                <!-- Break Reason Field -->
                <div class="input-block mb-3">
                  <label class="col-form-label">Break Reason </label>
                  <Field
                    :name="`break_reason_${index}`"
                    as="select"
                    class="form-control"
                    v-model="breakItem.reason"
                    :rules="editForm.is_break ? { required: true } : {}"
                  >
                    <option value="">Select Break Reason</option>
                    <option
                      v-for="reason in punchOutOptions"
                      :key="reason"
                      :value="reason"
                    >
                      {{ reason }}
                    </option>
                  </Field>
                  <ErrorMessage
                    :name="`break_reason_${index}`"
                    class="error-msg"
                  />
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label"
                        >Start Date <span class="text-danger">*</span></label
                      >
                      <div class="cal-icon">
                        <vue-datepicker
                          v-model="breakItem.start_date"
                          placeholder="Choose Date"
                          :min-date="editForm.punch_in_date"
                          :max-date="editForm.punch_out_date"
                          :enable-time-picker="false"
                          :auto-apply="true"
                          :clearable="false"
                          :format="dateFormat"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label">Start Time </label>
                      <div class="input-group time">
                        <a-time-picker
                          v-model:value="breakItem.start_time"
                          class="form-control timepicker"
                          placeholder="HH:mm"
                          :format="'HH:mm'"
                          :rules="editForm.is_break ? 'required' : ''"
                        />
                        <span class="input-group-text"
                          ><i class="fa-regular fa-clock"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label">End Date</label>
                      <div class="cal-icon">
                        <vue-datepicker
                          v-model="breakItem.end_date"
                          placeholder="Choose Date"
                          :min-date="editForm.punch_in_date"
                          :max-date="editForm.punch_out_date"
                          :enable-time-picker="false"
                          :auto-apply="true"
                          :clearable="false"
                          :format="dateFormat"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="input-block mb-3">
                      <label class="col-form-label">End Time </label>
                      <div class="input-group time">
                        <a-time-picker
                          v-model:value="breakItem.end_time"
                          class="form-control timepicker"
                          placeholder="HH:mm"
                          :format="'HH:mm'"
                          :disabled="!breakItem.start_time"
                          :rules="editForm.is_break ? 'required' : ''"
                        />
                        <span class="input-group-text"
                          ><i class="fa-regular fa-clock"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="text-end mb-3">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  @click="addNewBreak"
                >
                  Add Another Break
                </button>
              </div>
            </div>

            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Update</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- Edit Attendance Modal -->
</template>

<script>
import { Form, Field, ErrorMessage, defineRule } from "vee-validate";
import dayjs from "dayjs";
import axios from "axios";
import { notification } from "ant-design-vue";

// Define validation rules
defineRule("required", (value) => {
  if (!value || !value.length) {
    return "This field is required";
  }
  return true;
});

export default {
  emits: ["create-attendance", "update-attendance"],
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  props: {
    form: [Array, Object],
    editForm: [Array, Object],
    employeelist: {
      type: Array,
      default: () => [],
    },
    backendErrors: [Array, Object],
  },
  data() {
    return {
      punchOutOptions: ["On Break", "On Lunch", "On Hourly Leave"],
      dateFormat: "dd-MM-yyyy",
      maxDate: new Date(),
      maxPunchOutDate: null,
      defaultBreak: {
        reason: "",
        start_time: null,
        end_time: null,
        start_date: null,
        end_date: null,
        start_time_id: null,
        end_time_id: null,
      },
    };
  },
  watch: {
    "form.punch_in_date": {
      handler(newDate) {
        if (newDate) {
          const punchInDate = new Date(newDate);
          this.maxPunchOutDate = new Date(punchInDate);
          this.maxPunchOutDate.setDate(punchInDate.getDate() + 1); // Next day

          // Reset punch out date if it's outside the new range
          if (
            this.form.punch_out_date &&
            new Date(this.form.punch_out_date) > this.maxPunchOutDate
          ) {
            this.form.punch_out_date = null;
          }
        } else {
          this.maxPunchOutDate = null;
        }
      },
      immediate: true,
    },
    editForm(newValue) {
      if (newValue != null) {
        if (newValue?.punch_in_time) {
          this.editForm.punch_in_time = dayjs(
            newValue?.punch_in_time,
            "HH:mm:ss"
          );
        }

        if (newValue?.punch_out_time) {
          this.editForm.punch_out_time = dayjs(
            newValue?.punch_out_time,
            "HH:mm:ss"
          );
        }

        if (
          newValue.is_break &&
          (!newValue.break_details || newValue.break_details.length === 0)
        ) {
          this.editForm.break_details = [{ ...this.defaultBreak }];
        }

        if (newValue?.break_details) {
          this.editForm.break_details = newValue?.break_details.map(
            (breakItem) => ({
              ...breakItem,
              start_time: dayjs(breakItem?.start_time, "HH:mm:ss"),
              end_time: breakItem?.end_time
                ? dayjs(breakItem?.end_time, "HH:mm:ss")
                : null,
            })
          );
        }
      }
    },
  },
  methods: {
    handleBreakToggle(isChecked) {
      if (
        isChecked &&
        (!this.editForm.break_details ||
          this.editForm.break_details.length === 0)
      ) {
        this.editForm.break_details = [{ ...this.defaultBreak }];
      }
    },
    addNewBreak() {
      this.editForm.break_details.push({ ...this.defaultBreak });
    },
    removeBreak(index) {
      this.editForm.break_details.splice(index, 1);

      // const breakItem = this.editForm.break_details[index];

      // if (breakItem.start_time_id || breakItem.end_time_id) {
      //   axios
      //     .delete("employeeattendance/delete-break", {
      //       data: {
      //         start_time_id: breakItem.start_time_id,
      //         end_time_id: breakItem.end_time_id,
      //       },
      //     })
      //     .then((response) => {
      //       // loader.hide();
      //       this.editForm.break_details.splice(index, 1);

      //       notification.open({
      //         message: response.data.message,
      //         placement: "topRight",
      //         duration: process.env.VUE_APP_NOTIFICATION_DURATION,
      //         style: {
      //           background: process.env.VUE_APP_SUCCESS_COLOR,
      //         },
      //       });
      //     })
      //     .catch((error) => {
      //       console.error("Error deleting break:", error);
      //       // loader.hide();

      //       if (error.response) {
      //         var response = error.response;
      //         notification.open({
      //           message: response.data.message,
      //           placement: "topRight",
      //           duration: process.env.VUE_APP_NOTIFICATION_DURATION,
      //           style: {
      //             background: process.env.VUE_APP_WARNING_COLOR,
      //           },
      //         });
      //       }
      //     });
      // } else {
      //   this.editForm.break_details.splice(index, 1);
      // }
    },
    formatDisplayDate(date) {
      const dateObj = dayjs(date);

      return dateObj.format("DD-MM-YYYY");
    },
    getEmployeeName(id) {
      const employee = this.employeelist.find((e) => e.id === id);
      return employee ? employee.text : "";
    },
    getFormateDate(dateString) {
      if (dateString != null) {
        const date = new Date(dateString);

        return (
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1).toString().padStart(2, "0") +
          "-" +
          date.getDate().toString().padStart(2, "0")
        );
      } else {
        return null;
      }
    },
    getTimeFormate(dateTimeObject) {
      let date = new Date(dateTimeObject?.$d);

      if (date && date != null) {
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();

        const timeString = `${hours < 10 ? "0" : ""}${hours}:${
          minutes < 10 ? "0" : ""
        }${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
        return timeString;
      } else {
        return null;
      }
    },
    onSubmit(values) {
      let formattedData = {
        employee_id: "",
        // date: null,
        punch_from: "",
        punch_in_time: null,
        punch_out_time: null,
        punch_in_date: null,
        punch_out_date: null,
        is_break: null,
        break_reason: "",
        break_start_time: null,
        break_end_time: null,
        break_start_date: null,
        break_end_date: null,
      };

      formattedData = { ...this.form };

      // if (this.form.date) {
      //   formattedData.date = this.getFormateDate(this.form.date);
      // }
      if (this.form.punch_in_date) {
        formattedData.punch_in_date = this.getFormateDate(
          this.form.punch_in_date
        );
      }
      if (this.form.punch_out_date) {
        formattedData.punch_out_date = this.getFormateDate(
          this.form.punch_out_date
        );
      }
      if (this.form.punch_in_time) {
        formattedData.punch_in_time = this.getTimeFormate(
          this.form.punch_in_time
        );
      }

      if (this.form.punch_out_time) {
        formattedData.punch_out_time = this.getTimeFormate(
          this.form.punch_out_time
        );
      }

      if (this.form.break_start_time) {
        formattedData.break_start_time = this.getTimeFormate(
          this.form.break_start_time
        );
      }

      if (this.form.break_end_time) {
        formattedData.break_end_time = this.getTimeFormate(
          this.form.break_end_time
        );
      }
      if (this.form.break_start_date) {
        formattedData.break_start_date = this.getFormateDate(
          this.form.break_start_date
        );
      }
      if (this.form.break_end_date) {
        formattedData.break_end_date = this.getFormateDate(
          this.form.break_end_date
        );
      }

      this.$emit("create-attendance", formattedData);
    },
    onUpdate(values) {
      const formattedData = {
        employee_id: this.editForm.employee_id,
        employee_attendances_id: this.editForm.employee_attendances_id,
        date: this.editForm.date
          ? this.getFormateDate(this.editForm.date)
          : null,
        punch_in_date: this.editForm.date
          ? this.getFormateDate(this.editForm.punch_in_date)
          : null,
        punch_out_date: this.editForm.date
          ? this.getFormateDate(this.editForm.punch_out_date)
          : null,
        punch_in_time: this.editForm.punch_in_time
          ? this.getTimeFormate(this.editForm.punch_in_time)
          : null,
        punch_out_time: this.editForm.punch_out_time
          ? this.getTimeFormate(this.editForm.punch_out_time)
          : null,
        is_break: this.editForm.is_break,
        break_details: this.editForm.is_break
          ? this.editForm.break_details.map((breakItem) => ({
              ...breakItem,
              start_time: breakItem.start_time
                ? this.getTimeFormate(breakItem.start_time)
                : null,
              end_time: breakItem.end_time
                ? this.getTimeFormate(breakItem.end_time)
                : null,
              start_date: breakItem.start_date
                ? this.getFormateDate(breakItem.start_date)
                : null,
              end_date: breakItem.end_date
                ? this.getFormateDate(breakItem.end_date)
                : null,
              start_time_id: breakItem.start_time_id || null,
              end_time_id: breakItem.end_time_id || null,
            }))
          : [],
      };

      this.$emit("update-attendance", formattedData);
    },
    closeDialog() {
      this.$refs.addattendanceclose.click();
      this.$refs.editattendanceclose.click();
    },
  },
  setup() {},
};
</script>

<style scoped>
.error-msg {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}
.date-error {
  border: 1px solid red;
  border-radius: 5px;
}

.break-section {
  border: 1px solid #eee;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 15px;
}
</style>
